import { qrMenuGET } from 'featureSliced/shared/api/qrMenu/GET'
import { SpecialsSlice } from '.'
import { AppDispatch } from '../../index'

export const getSpecialPrices = () => async (dispatch: AppDispatch) => {
  const result: any[] = await qrMenuGET.getSpecials()
  dispatch(
    SpecialsSlice.actions.setSpecials({
      isSpecialsLoaded: true,
      discounts: result?.[0]?.discounts,
      individualPrices: result?.[1]?.individualPrices,
      productListWithPrices: result?.[2]?.productListWithPrices,
    })
  )
}
